<template>
  <el-card shadow="never">
    <el-form inline>
      <el-form-item>
        <el-input v-model="formData.lendOrderCode" placeholder="借出单号" clearable style="width: 250px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="formData.materialCode" placeholder="备件编码" clearable style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formData.emergencyDegree" placeholder="紧急程度" clearable style="width: 200px" filterable>
          <el-option v-for="item in emergencyDegreeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save" :loading="loading">保存</el-button>
      </el-form-item>
      <div style="color: orange;font-size: 12px">提示：1、只允许将空改为有值的， 并且状态是创建的。2、分拣完成就不允许改。</div>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: "UrgentManage",
  data() {
    return {
      formData: {
        lendOrderCode: '',
        materialCode: '',
        emergencyDegree: '',
      },
      loading: false
    }
  },
  computed: {
    emergencyDegreeList() {
      return this.$store.getters.getDictList('emergencyDegree') || [];
    },
  },
  methods: {
    save() {
      if (!this.formData.lendOrderCode) {
        return this.$message.error('借出单号不能为空！');
      }
      if (!this.formData.materialCode) {
        return this.$message.error('备件编码不能为空！');
      }
      if (!this.formData.emergencyDegree) {
        return this.$message.error('紧急程度不能为空！');
      }
      if (this.formData.emergencyDegree === '') {
        return this.$message.error('紧急程度不能改为‘空’！');
      }
      this.loading = true;
      this.$axios.post('lendOrder/updateUrgentItem', this.formData).then(response => {
        this.loading = false;
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        const count = res.data || 0;

        this.formData.lendOrderCode = ''
        this.formData.materialCode = ''
        this.formData.emergencyDegree = ''
        return this.$message.success('操作成功，更新条数：' + count);
      }, error => {
        this.loading = false;
        return this.$message.error('操作失败，' + error.message);
      });

    }
  }
}
</script>

<style scoped>

</style>